import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PersonalInfoService } from 'src/app/personal-info/services/personal-info.service';
import { AuthService } from '../../msal/auth.service';
import { CommonService } from '../../services/common.service';
import { SearchUpdateConfirmationComponent } from '../search-update-confirmation/search-update-confirmation.component';

@Component({
  selector: 'app-personal-info-sub-menu',
  templateUrl: './personal-info-sub-menu.component.html',
  styleUrls: ['./personal-info-sub-menu.component.scss']
})
export class PersonalInfoSubMenuComponent implements OnInit {
  @Output() closeSidebarHeader = new EventEmitter<any>();
  public url: string = '';
  @ViewChild('changeMenuModal', { static: true })
  public changeMenuModal: SearchUpdateConfirmationComponent | any;
  menu: string = '';
  isDelegateUser: boolean = false;
  constructor(private personalInfoService: PersonalInfoService,
    private router: Router,
    private commonSerice: CommonService, private authService: AuthService
  ) {
    setTimeout(() => {
      this.authService.subscribeToUrl((url: any) => {
        this.url = url;
      })
    }, 0);

    if(sessionStorage.getItem('currentUrl'))
      {
        this.url = sessionStorage.getItem('currentUrl') as string;        
      }
  }
  //return the selected menu
  get selectedMenu(): string {
    return this.personalInfoService.selectedMenu;
  }

  ngOnInit(): void {    
    this.isDelegateUser = this.commonSerice.getIsDelegateLoggedIn();
    this.personalInfoService.updateSelectedMenu('photos');
  }

  /**
  * check if the menu is selected or not
  * @param menuItem 
  * @return boolean
  */

  public isMenuSelected(menuItem: string): boolean {
    return this.selectedMenu === menuItem;
  }

  /**
 * update the selected menu
 * @param menuItem 
 */

  public selectMenu(menuItem: string): void {
    if (this.router.url !== '/portal/personal-info/' + menuItem) {
      this.menu = menuItem;
      this.closeSidebarHeader.emit(true);
      if (!this.url.includes(this.menu))
       this.commonSerice.redirectToNewPage('/portal/personal-info/' + this.menu);
    }
  }


}
